import { GenIcon } from 'react-icons/lib';

export const IcoMoonSpinner4 = props =>
  GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 32 32' },
    child: [
      {
        tag: 'path',
        attr: {
          d:
            'M6 16c0-.381.022-.756.063-1.126L.282 12.996A16.07 16.07 0 0 0-.001 16c0 4.601 1.943 8.748 5.052 11.666l3.571-4.916a9.964 9.964 0 0 1-2.623-6.751zm20 0a9.964 9.964 0 0 1-2.623 6.751l3.571 4.916A15.954 15.954 0 0 0 32 16.001a16.07 16.07 0 0 0-.283-3.004l-5.781 1.878c.041.37.063.745.063 1.126zm-8-9.8a10.014 10.014 0 0 1 6.702 4.87l5.781-1.878C28.196 4.335 23.538.815 18.001.125v6.076zM7.298 11.07A10.017 10.017 0 0 1 14 6.2V.124C8.463.815 3.805 4.334 1.518 9.191l5.78 1.878zm12.844 14.034C18.88 25.679 17.477 26 16 26s-2.88-.321-4.142-.896L8.286 30.02C10.574 31.281 13.203 32 16 32s5.426-.719 7.714-1.98l-3.572-4.916z'
        }
      }
    ]
  })(props);
IcoMoonSpinner4.displayName = 'IcoMoonSpinner4';
